import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1IssuersEdit } from "./edit";
import { D1IssuersNew } from "./new";
import { D1IssuersTable } from "./table";

export default function D1Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1IssuersEdit />} />
      <Route index element={<D1IssuersTable />} />
      <Route path="/new" element={<D1IssuersNew />} />
    </Routes>
  );
}
